import { useQuery } from '@tanstack/react-query';

import { type Membership, MEMBERSHIP_ROLES } from 'src/features/userManagement/types';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListResponse, ListDTO } from 'src/types';

const RESOURCE = '/parkings/:parkingId/memberships/';

interface DTO extends ListDTO {
    parkingId: string;
    role?: MEMBERSHIP_ROLES[];
    status?: 'active' | 'inactive';
    user__is_staff?: boolean;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, role, ...params }: DTO): Promise<ListResponse<Membership>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), {
        params: {
            ...params,
            ...(role ? { role: role } : {}),
        },
    });
};

interface UseQueryOptions extends DTO {
    options?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ options, ...payload }: UseQueryOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => {
            return await queryFn(payload);
        },
        ...options,
    });

export { RESOURCE as LIST_MEMBERSHIPS_RESOURCE, queryFn as listMemberships, useQueryHook as useListMemberships };
export type { DTO as ListMembershipsDTO };
